<script>
  import { longpress } from "./actions.js";
  import { entityData, time, meta } from "./store.js";
  export let entity = null;

  function click() {
    setClicked();
    entityData.update(ed => ({
      ...ed,
      [entity]: {
        ...ed[entity],
        count: ((ed[entity] && ed[entity].count) || 0) + 1,
        update: $time
      }
    }));
  }

  function clickLong() {
    setClicked();
    entityData.update(ed => ({
      ...ed,
      [entity]: {
        ...ed[entity],
        count: ((ed[entity] && ed[entity].count) || 0) - 1,
        update: $time
      }
    }));
  }

  function setClicked() {
    clicked = true;
    setTimeout(() => {
      clicked = false;
    }, 300);
  }

  let clicked = false;

  let dist;
  let pace;
  $: dist =
    (($entityData[entity] && $entityData[entity].count) || 0) * $meta.laps;
  $: pace = Math.floor($time / 10 / dist); //(s/100m)
  $: pacef = [
    !Number.isFinite(pace) ? " " : Math.floor(pace / 60),
    !Number.isFinite(pace) ? " " : pace % 60
  ];

  $: color =
    $entityData[entity] &&
    mapColor(map(($time - $entityData[entity].update) / 1000, 0, pace, 0, 1));

  function map(num, min, max, rmin, rmax) {
    const n = ((num - min) * (rmax - rmin)) / (max - min) + rmin;
    return Math.max(Math.min(n, rmax), rmin);
  }

  function mapColor(range) {
    const h1 = 120;
    const h2 = 0;
    const h = h1 + (h2 - h1) * range;
    return `hsl(${h | 0}, 40%, 80%)`;
  }
</script>

<style>
  button {
    border: 0px;
    width: 90px;
    height: 90px;
    background: papayawhip;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0.1rem;
    overflow: hidden;
  }
  .title {
    margin: 0.4rem 0px 0px 0px;
    width: 100%;
    font-size: 0.9rem;
    text-align: center;
    white-space: nowrap;
    text-overflow: "";
    overflow: hidden;
    font-weight: 100;
  }
  .count {
    font-size: 1.3rem;
    margin: 0px;
    flex-grow: 2;
    display: flex;
    align-items: center;
  }
  .detail {
    font-size: 0.7rem;
    margin: 0px;
  }
  .sub {
    font-size: 0.5rem;
  }
  .click {
    animation: anim-effect 0.3s forwards;
  }

  @keyframes anim-effect {
    0% {
      transform: scale3d(1, 1, 1);
    }
    25%,
    50% {
      transform: scale3d(1.2, 1.2, 1);
    }
    100% {
      transform: scale3d(1, 1, 1);
    }
  }
</style>
<button class:click={clicked} use:longpress on:longpress={clickLong} on:shortpress={click} style={`background-color:${color};`}>
  <h2 class="title">{entity}</h2>
  <p class="count">{$entityData[entity] && $entityData[entity].count || 0}</p>
  <p class="detail">{dist}m</p>
  <p class="detail">{pacef[0]}'{pacef[1]}''<span class="sub">/100m</span></p>
</button>